import { z } from 'zod';

// Password validation
export const PASSWORD_MIN_LENGTH = 8;
// Updated regex to support a wider range of special characters
export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).+$/;

export const loginSchema = z.object({
    email: z.string().min(1, { message: 'auth.validation.required' }).email({ message: 'auth.validation.invalidEmailFormat' }),
    password: z.string().min(1, { message: 'auth.validation.required' }),
});

export const signupSchema = z
    .object({ //TODO: Review password complexity message with proper translation key
        email: z.string().min(1, { message: 'auth.validation.required' }).email({ message: 'auth.validation.invalidEmailFormat' }),
        password: z
            .string()
            .min(PASSWORD_MIN_LENGTH, { message: 'auth.validation.passwordTooShort' }) // Use key, maybe need a specific one with length?
            .regex(PASSWORD_REGEX, { message: 'auth.validation.passwordComplexity' }), // TODO: Add auth.validation.passwordComplexity key
        marketingEmails: z.boolean().optional().default(false),
    });

// Add type safety with Zod inference
export type LoginFormData = z.infer<typeof loginSchema>;
export type SignupFormData = z.infer<typeof signupSchema>;


export const forgotPasswordSchema = z.object({
    email: z.string().min(1, { message: 'auth.validation.required' }).email({ message: 'auth.validation.invalidEmailFormat' }),
});

export const resetPasswordSchema = z
    .object({ // Reuse keys from signup
        password: z
            .string()
            .min(PASSWORD_MIN_LENGTH, { message: 'auth.validation.passwordTooShort' })
            .regex(PASSWORD_REGEX, { message: 'auth.validation.passwordComplexity' }),
        confirmPassword: z.string().min(1, { message: 'auth.validation.required' }),
    })
    .refine((data) => data.password === data.confirmPassword, {
        message: 'auth.validation.passwordsDontMatch',
        path: ['confirmPassword'],
    });

// Add type safety for forgot password form
export type ForgotPasswordFormData = z.infer<typeof forgotPasswordSchema>;
export type ResetPasswordFormData = z.infer<typeof resetPasswordSchema>;
